import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Fahrdienst',
  moduleId: MODULE_ID,
  api: 'fahrdienst',

  routeHandler,
};

export default module;
